<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col md="6" sm="12">
        <create-token :default-permissions="defaultPermissions" :available-permissions="availablePermissions" />
      </v-col>
      <v-col md="6" sm="12">
        <tokens :tokens="tokens" :available-permissions="availablePermissions" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import CreateToken from '@/Components/API/CreateToken.vue'
import Tokens from '@/Components/API/Tokens.vue'

export default {
   metaInfo: { title: 'API Tokens' },

   components: {
      CreateToken,
      Tokens
   },

   layout: (h, page) => h(Layout, [page]),

   props: {
      tokens: {
         type: Array,
         default () { return [] }
      },
      availablePermissions: {
         type: Array,
         required: true
      },
      defaultPermissions: {
         type: Array,
         required: true
      },
   },
}
</script>

<style>

</style>
